import moment from 'moment';
import Tooltip from 'rc-tooltip';
import { FC } from 'react';

import { TimeRange, formatSeconds } from '@/core/time';
import { darkBlue, orange500, red500, teal500 } from '@/theme/colors';

import s from './TimelineEvent.module.scss';
import { Event } from './participant';

function attemptRangeSeconds(start: any, end: any) {
  try {
    return new TimeRange(start, end).duration().seconds();
  } catch {
    // ignore ranges where end is before start
  }
}

const levelColor = {
  ERROR: red500,
  WARNING: orange500,
  INFO: darkBlue,
};

// Event dots can overlap on the UI, messages that are important suc as error
// should appear on the top
const eventZIndex = {
  ERROR: 40,
  WARNING: 30,
  INFO: 20,
};

const groupLabel: { [key: string]: string } = {
  'network-quality-warning-raised': 'network',
  'audio-level-warning-raised': 'audio',
};

interface TimelineEventProps {
  event: Event;
  callId: string;
  range: TimeRange;
  conferenceDuration: number;
}

const TimelineEvent: FC<TimelineEventProps> = ({ event, callId, range, conferenceDuration }) => {
  const percentPerSecond = 100 / conferenceDuration;

  const secondsUntilEvent = attemptRangeSeconds(moment(range.start), moment(event.timestamp));

  if (!secondsUntilEvent) return null;

  let zIndex = eventZIndex[event.level];
  // Events with message have priority
  if (event.payload && event.payload.message) zIndex += 1;

  const color = levelColor[event.level] || teal500;
  const style = {
    backgroundColor: color,
    border: `1px solid rgba(0, 0, 0, 0.2)`,
    left: `${secondsUntilEvent * percentPerSecond}%`,
    zIndex,
  };

  const tooltip = (
    <div>
      {formatSeconds(secondsUntilEvent)}&nbsp;
      <span style={{ color: levelColor[event.level] }}>{event.level}</span>
      &nbsp; [{groupLabel[event.group] || event.group}] {event.name}
      {event.payload && event.payload.message && <div>{event.payload.message}</div>}
    </div>
  );

  return (
    <Tooltip overlay={tooltip} trigger={['hover']} placement="top">
      <a
        href={`https://www.twilio.com/console/voice/calls/logs/${callId}/events`}
        target="__blank"
        className={s.event}
        style={style}
      />
    </Tooltip>
  );
};

export default TimelineEvent;
